import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseResponse } from '../models/base-response.model';

export interface StringDataResponse extends BaseResponse {
  result?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class ArtifactService {
  #http = inject(HttpClient);

  getBase64Media(url: string) {
    return this.#http.get(url).pipe(
        map((response: any) => {
            return response.result
        }),
      catchError(() => of(''))
    )
  }
}
